module.exports = __webpack_public_path__ + "static/media/bao2.4330210d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/bao2.png
// module id = 427
// module chunks = 0